import { AbstractControl, ValidatorFn } from '@angular/forms';

export function priceValidator(minPrice: number, maxPrice: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {

    if (!control.parent || !control) {
      return null;
    }

    if (control.value === null) return null;

    const valueString = control.value.toString();

    if (valueString === '') {
      return null;
    }

    const value = parseFloat(valueString);
    if (isNaN(value)) return { required: true }

    if (value >= minPrice && value <= maxPrice) {
      return null;
    }

    if (value < minPrice) {
      return { valueTooSmall: true };
    }

    if (value > maxPrice) {
      return { valueTooBig: true };
    }

  }
}
